var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "container relative" }, [
    _c(
      "div",
      { staticClass: "bg-blue-lighter py-4 md:mb-4" },
      [
        _c(
          "Swiper",
          {
            ref: "quoteSwiper",
            staticClass: "h-full w-full",
            attrs: { options: _vm.contentOptions },
          },
          _vm._l(_vm.slides, function (slide, index) {
            return _c("SwiperSlide", { key: index }, [
              _c(
                "div",
                { staticClass: "swiper-slide__container text-center" },
                [
                  slide.fields.content
                    ? _c("RichTextRenderer", {
                        attrs: {
                          document: slide.fields.content,
                          "node-renderers": _vm.renderNodes(),
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ])
          }),
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "bullets" },
          _vm._l(_vm.slides, function (slide, index) {
            return _c("span", {
              key: index,
              staticClass: "bullet",
              class: { active: index + 1 === _vm.active },
              attrs: { tabindex: "0" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return (() => {
                    _vm.goToSlide(index + 1)
                    _vm.touched = false
                  }).apply(null, arguments)
                },
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return (() => {
                    _vm.goToSlide(index + 1)
                    _vm.touched = false
                  }).apply(null, arguments)
                },
              },
            })
          }),
          0
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }